$(() => {
    (<any>$("#inscricao-celular")).mask('(99) 99999-9999');
    (<any>$("#inscricao-nascimento")).mask('99/99/9999');
    (<any>$("#inscricao-cpf")).mask('999.999.999-99');

    $("#inscricao-btn-save").click(function(e) {
        e.stopPropagation();
        (<any>$('#inscricao-btn-save')).buttonLoader('start');
        $("#inscricao-error").hide();

        let data = {
            'action': 'inscricoes/save',
            'nome': $("#inscricao-nome").val(),
            'email': $("#inscricao-email").val(),
            'celular': $("#inscricao-celular").val(),
            'cpf': $("#inscricao-cpf").val(),
            'nascimento': $("#inscricao-nascimento").val(),
            'sexo': $("input[name=inscricao-sexo]:checked").val(),
            'categoria': $("input[name=inscricao-categoria]:checked").val(),
            'endereco': $("#inscricao-endereco").val(),
            'evento': $(this).attr('data-ref'),
        }

        $.post("/load/acmanager", data, function (r) {
            let response: any = $.parseJSON(r);
            (<any>$('#inscricao-btn-save')).buttonLoader('stop');
            if (response.response) {
                $("#inscricao-form").hide();
                $("#inscricao-success").show();
                $("#inscricao-success-numero").html("Número: " + response.id);
            } else {
                $("#inscricao-" + response.id).focus();
                $("#inscricao-error").html(response.error).show();
            }
        });
    });
});